import { render, staticRenderFns } from "./BrandSignature.vue?vue&type=template&id=53f176c8&scoped=true"
import script from "./BrandSignature.vue?vue&type=script&lang=js"
export * from "./BrandSignature.vue?vue&type=script&lang=js"
import style0 from "./BrandSignature.vue?vue&type=style&index=0&id=53f176c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f176c8",
  null
  
)

export default component.exports